var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'promo--home': _vm.isHome, 'promo--hide': _vm.isHide},attrs:{"id":"promo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }